require('./bootstrap');

import * as bootstrap from 'bootstrap';
//import 'jquery-form-styler';
import '@fortawesome/fontawesome-free'
import 'slick-carousel';
import 'datatables/media/js/jquery.dataTables';
import 'datatables/media/js/jquery.dataTables';
import 'datatables.net-buttons/js/buttons.html5'
import 'datatables.net-buttons/js/buttons.print'
import 'datatables.net-buttons/js/dataTables.buttons'
import 'datatables.net-bs/js/dataTables.bootstrap'
import 'swiper/bundle';
import 'jquery-datetimepicker'


global.$ = global.jQuery = require('jquery');
global.gritter = require('gritter/js/jquery.gritter');
window.JSZip = global.JSZip = require('jszip');


(function ($) {
    "use strict";
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name = "csrf-token"]').attr('content')
        }
    });
})($);

window.addEventListener('DOMContentLoaded', event => {

    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl);
    });

    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl);
    });

    const stickyNav = document.body.querySelector('#stickyNav');
    if (stickyNav) {
        new bootstrap.ScrollSpy(document.body, {
            target: '#stickyNav',
            offset: 82,
        });
    }

    const sidebarToggle = document.body.querySelector('#sidebarToggle');
    if (sidebarToggle) {
        sidebarToggle.addEventListener('click', event => {
            event.preventDefault();
            document.body.classList.toggle('sidenav-toggled');
            localStorage.setItem('sb|sidebar-toggle', document.body.classList.contains('sidenav-toggled'));
        });
    }

    const sidenavContent = document.body.querySelector('#layoutSidenav_content');
    if (sidenavContent) {
        sidenavContent.addEventListener('click', event => {
            const BOOTSTRAP_LG_WIDTH = 992;
            if (window.innerWidth >= 992) {
                return;
            }
            if (document.body.classList.contains("sidenav-toggled")) {
                document.body.classList.toggle("sidenav-toggled");
            }
        });
    }

    let activatedPath = window.location.pathname.match(/([\w-]+\.html)/, '$1');

    if (activatedPath) {
        activatedPath = activatedPath[0];
    } else {
        activatedPath = 'index.html';
    }

    const targetAnchors = document.body.querySelectorAll('[href="' + activatedPath + '"].nav-link');

    targetAnchors.forEach(targetAnchor => {
        let parentNode = targetAnchor.parentNode;
        while (parentNode !== null && parentNode !== document.documentElement) {
            if (parentNode.classList.contains('collapse')) {
                parentNode.classList.add('show');
                const parentNavLink = document.body.querySelector(
                    '[data-bs-target="#' + parentNode.id + '"]'
                );
                parentNavLink.classList.remove('collapsed');
                parentNavLink.classList.add('active');
            }
            parentNode = parentNode.parentNode;
        }
        targetAnchor.classList.add('active');
    });
});

$(document).ready(function () {
    $('#datatable').DataTable({
        language: {
            url: '/dt_ru.json'
        }
    });
});

/* menu mobile */

$('.header__burger').on('click', function () {
    $('.header__menu').toggleClass('active');
});

$('#password_check').click(function(){
    if($(this).prop('checked')) {
        $('#password').attr('type','text');
        $('#password_confirmation').attr('type','text');
    } else {
        $('#password').attr('type','password');
        $('#password_confirmation').attr('type','password');
    }
});

$('#work_free').click(function(){
    if($(this).prop('checked')) {
        $('#organization').val('Не работаю (не учусь)').prop( "disabled", true );
    } else {
        $('#organization').val('').prop( "disabled", false );
    }
});
